export const BREAK_REASON_OTHER = 'Other';
export const BREAK_REASON_OPTIONS = [
    { label: 'Lunch Break', value: 'Lunch Break' },
    { label: 'Tea / Coffee Break', value: 'Tea / Coffee Break' },
    { label: 'Prayer Break', value: 'Prayer Break' },
    { label: 'Meeting', value: 'Meeting' },
    { label: 'Training', value: 'Training' },
    { label: 'Personal Break', value: 'Personal Break' },
    { label: 'Technical Issue', value: 'Technical Issue' },
    { label: BREAK_REASON_OTHER, value: BREAK_REASON_OTHER },
];
